<template>
  <BaseModal :modalTitle="$t('area.business-central.invoice.action.resend-invoice-title')">
    <div class="flex flex-col gap-4">
      <span class="text-sm text-text-secondary">
        {{ $t('W: Business Central sender fakturaen igen til den modtager, der er registreret på kunden i BC') }}
      </span>
      <span
        v-if="bcUrl"
        class="text-sm text-text-secondary">
        {{ $t('W: Skal den til en anden adresse, vælges modtageren i Business Central — fakturaen er bogført, så adressen kan ikke længere ændres herfra') }}
      </span>
      <span
        v-if="errorText"
        class="text-sm wrap-break-word text-feedback-error">
        {{ errorText }}
      </span>
      <div class="flex items-center justify-end gap-3">
        <a
          v-if="bcUrl"
          :href="bcUrl"
          target="_blank"
          rel="noopener"
          class="text-sm text-text-secondary underline">
          {{ $t('W: Åbn i Business Central') }}
        </a>
        <UiBaseButton
          :text="$t('area.business-central.invoice.action.resend')"
          :isLoading="isLoading"
          :showSaveIcon="showSaveIcon"
          @button-click="onSubmit" />
      </div>
    </div>
  </BaseModal>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import { mapActions, mapState } from 'pinia'
import { useModalStore } from '@/stores/modalStore'
import { useAppStore } from '@/stores/appStore'
import { useToast } from '@/globals/typescript/utils/toast'

export default {
  name: 'ResendBcInvoiceModal',

  props: {
    /** Deep link to the posted invoice in BC, or '' when the connection snapshot is incomplete —
     *  the "send it somewhere else" route, since the API cannot choose a recipient. */
    bcUrl: { type: String, default: '' },
    onConfirm: { type: Function as PropType<() => Promise<void>>, required: true },
  },

  data() {
    return {
      isLoading: false,
      showSaveIcon: false,
      errorText: '',
    }
  },

  computed: {
    ...mapState(useAppStore, ['defaultMessageSaveIconTime']),
  },

  methods: {
    ...mapActions(useModalStore, ['closeTop']),

    async onSubmit(): Promise<void> {
      this.errorText = ''
      this.isLoading = true
      try {
        await this.onConfirm()
        this.showSaveIcon = true
        setTimeout(() => {
          this.showSaveIcon = false
        }, this.defaultMessageSaveIconTime)
        useToast().success(this.$t('area.business-central.invoice.message.resent'))
        this.closeTop()
      } catch (err) {
        this.errorText = err instanceof Error && err.message ? err.message : this.$t('error.common.standard')
        useToast().error(this.errorText)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
